module.exports = __webpack_public_path__ + "components/flag/static/square/gm-0d5babc49a27c4f20794034d5a0cfa20.svg";